import React, { useMemo } from "react";
import { Col, Row, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import elefinLogo from "../../../assets/images/elefin-black.png";
import imageLists from "../../../assets/images/partner/list.json";
import { Link } from "react-router";
import { NAVIGATIONS } from "../../..";
import { ELEFIN_HOME } from "../../../constants";
import { shuffleArray } from "../../../helpers";

const COUNT_IMAGE = 12;
const FOLDERS = ["food_beverages", "hotel", "healthcare", "others"];

function PoFinancingPartner() {
  const images = useMemo(() => {
    let images = Object.entries(imageLists)
      .filter(
        ([folderName, content]) =>
          FOLDERS.includes(folderName) && content !== null
      )
      .flatMap(([folderName, content]) => {
        return Object.values(content)
          .filter((entry: any) => entry.products.includes(`po-financing`))
          .map((entry: any) => ({
            src: require(
              `../../../assets/images/partner/${folderName}/${entry.file}`
            ),
            products: entry.products,
            name: entry.image_name,
          }));
      })
    shuffleArray(images)
    return images.slice(0, COUNT_IMAGE);
  }, []);

  return (
    <React.Fragment>
      <Row className="align-items-start mt-5">
        <Col lg={4} md={12} sm={12}>
          <div className="text-size-title-2 fw-extra-bold text-secondary-dark text-center text-lg-start">
            <span className="text-primary-main">Pengguna </span>
          </div>
          <div className="text-size-title-2 fw-extra-bold text-secondary-dark text-center text-lg-start">
            <span>PO Financing </span>
          </div>
          <div className="text-size-sub-body d-flex align-items-center justify-content-center justify-content-lg-start mt-2">
            <span className="text-size-sub-body">Melalui </span>
            <OverlayTrigger placement="right" overlay={
              <Tooltip>
                <div>
                  Kunjungi elefin.id, sistem B2B procurement dan tempat belanja kebutuhan usaha Anda
                </div>
              </Tooltip>
            }>
              <a href={ELEFIN_HOME} target="_blank" rel="noreferrer">
                <Image src={elefinLogo} fluid width={120} className="ms-2" />
              </a>
            </OverlayTrigger>
          </div>
        </Col>
        <Col lg={8} md={12} sm={12} className="mt-4 mt-lg-0 ps-2">
          <Row>
            {images.map((a, idx) => (
              <Col
                xl={2}
                lg={3}
                md={4}
                sm={6}
                xs={12}
                className="mt-4 mb-2"
                key={`partner-${idx}`}
              >
                <div className="text-center">
                  <OverlayTrigger overlay={
                    <Tooltip id={a.name}>
                      {a.name}
                    </Tooltip>
                  }>
                    <Image src={a.src} fluid className="mt-2" />
                  </OverlayTrigger>
                </div>
              </Col>
            ))}
          </Row>
        </Col>
        <div className="mt-4 text-end text-size-sub-body-2">
          <Link to={`${NAVIGATIONS.partner}?filter=po-financing`}>
            Tampilkan Semua
          </Link>
        </div>
      </Row>
    </React.Fragment>
  );
}

export default PoFinancingPartner;
